<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card min-width="400px">
            <template>
                <v-stepper v-model="currentStep">
                    <v-stepper-header>
                        <v-stepper-step :complete="currentStep > 1" step="1">{{this.model == null ? '...' : this.model.id}}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 2" step="2">Package Data</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <p-setup-info ref="p-setup-info"></p-setup-info>
                            <v-card class="ma-0 pa-0 mt-4" elevation="0">
                                <v-card-actions class="ma-0 pa-0">
                                    <v-btn :disabled="model == null" color="primary" @click="onCompleteInfoStep">Continue<v-icon>mdi-chevron-right</v-icon></v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="red" class="white--text" @click="onClose">cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <p-setup-data ref="p-setup-data" v-on:show-p-file-preview-popup="onPreviewPackage"></p-setup-data>
                            <v-card class="ma-0 pa-0 mt-4" elevation="0">
                                <v-card-actions class="ma-0 pa-0">
                                    <v-btn :disabled="model == null" color="primary" @click="onCompleteDataStep" :loading="saving">DONE<v-icon>mdi-chevron-right</v-icon></v-btn>
                                    <v-btn text @click="currentStep = 1"><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="red" class="white--text" @click="onClose">cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
                </template>
        </v-card>
    </v-dialog>
</template>

<script>

import {PackageType} from "@/modules/mpackages/models/PackeageType";
import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import PSetupData from "@/modules/mpackages/views/popups/p-add-package-popup/p-setup-data";
import PSetupInfo from "@/modules/mpackages/views/popups/p-add-package-popup/p-setup-info";
import {PackageBackendModel} from "@/modules/mpackages/models/PackageBackendModel";
import {serialize} from "serializr";

export default {
    name: "p-add-package-popup",
    components: {PSetupInfo, PSetupData},
    data: () => ({
        currentStep: 1,
        dialog: false,
        model: null,
        saving:false,
    }),
    computed: {
        types(){
            return PackageType.getValues()
        },
    },
    methods: {
        onPreviewPackage(packageId, fileName){
            this.$emit('show-p-file-preview-popup', packageId, fileName)
        },
        onCompleteInfoStep(){
            let model = this.$refs['p-setup-info'].validate()
            if (model.data != null){
                this.model = model.data
            }else{
                this.$notify({title: 'Invalid info data', text: model.error, type: "error"});
                return
            }
            this.currentStep = 2
            this.$refs['p-setup-data'].setModel(this.model)
        },
        onCompleteDataStep(){

            let dataExist = this.$refs['p-setup-data'].validate()
            if (!dataExist){
                this.$notify({title: 'Reward JSON not imported', text: '', type: "error"});
                return;
            }

            this.saving = true
            PackageStoreUtils.updatePackage(serialize(PackageBackendModel, this.model))
            .then(() => {
                this.saving = false
                this.dialog = false
                this.$notify({title: 'Package successfully saved!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.saving = false
                this.dialog = false
                this.$notify({title: 'Package save failed!', text: error, type: "error"});
            })
        },
        show(packageId, editMode) {
            this.model = null
            this.dialog = true
            this.editMode = editMode
            this.currentStep = 1
            let model = PackageStoreUtils.getPackages().find(e => e.id == packageId)
            if (model == undefined){
                PackageStoreUtils.getNewPackage()
                    .then((data) => {
                        this.loading = false
                        this.model = data[0]
                        this.$refs["p-setup-info"].setModel(this.model)
                        this.$notify({title: 'Package successfully created!', text: "", type: "succes"});
                    })
                    .catch((error) => {
                        this.loading = false
                        this.$notify({title: 'Package create failed!', text: error, type: "error"});
                    })
            }else{
                this.model = model;
                this.$nextTick(() => {
                    this.$refs["p-setup-info"].setModel(this.model)
                });
            }
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            if (this.editMode){
                this.dialog = false
            }else{
                this.$confirm("Are you sure?")
                .then(() => {
                    this.dialog = false
                    if (this.model != null){
                        PackageStoreUtils.deletePackage(this.model.id)
                    }
                }).catch(() => {})
            }
        },
    }
}
</script>

<style scoped>

</style>